// 导出 PageConfig 接口供其他文件使用
export type { PageConfig } from "../hooks/usePageConfig";

// 路由配置
export const ROUTES = {
  // 首页
  HOME: "/",
  HOME_ALT: "/home",

  // VIP页面
  VIP: "/vip",

  // VIP Center 页面（新）
  VIP_CENTER: "/vip-center",

  // 维护页面
  REPAIR: "/repair",
  MAINTAIN: "/maintain",

  // 落地页
  LANDING_PAGE: "/common/store/apps/details",

  // 游戏相关
  GAMES: "/games",
  GAME_SEARCH: "/game-search",
  GAME_DETAIL: "/game/:id",

  // 用户相关
  PROFILE: "/profile",
  SETTINGS: "/settings",
  LOGIN: "/login",
  REGISTER: "/register",
  REGISTER_NEW: "/register-new",
  AGENT_CENTER: "/agent-center",
  INVITE_FRIENDS: "/invite-friends",
  AGENT_COMMISSION: "/agent-commission",
  RECHARGE: "/recharge",
  WITHDRAW: "/withdraw",
  RECORDS_DEPOSIT: "/records-deposit",
  ACCOUNT_DETAILS: "/account-details",
  REDEEM: "/redeem",
  PROMOTION_DETAILS: "/promotion-details",
  RECHARGE_PROMO: "/recharge-promo",
  EVENT_DETAILS: "/event-details",
  /** 救援金规则说明页（展示 admin 配置的 ruleTitle + ruleDescription markdown） */
  RESCUE_FUND_RULE: "/rescue-fund-rule",
  MESSAGE_CENTER: "/message-center",
  MESSAGE: "/message/:id",
  EVENT_CENTER: "/event-center",
  REDPACKET: "/redpacket",

  // 未支付订单
  UNPAID_ORDERS: "/unpaid-orders",

  // 测试页面
  COMPONENT_TEST: "/component-test",

  // 其他
  NOT_FOUND: "*",
  EMBED: "/embed",
} as const;

// RECORDS_DEPOSIT 页面的 Tab 索引定义
export const RECORDS_DEPOSIT_TABS = {
  DEPOSIT: 0,
  WITHDRAW: 1,
  ROLLOVER: 2,
  BET: 3,
  BONUS: 4,
} as const;

// Tab 索引类型
export type RecordsDepositTabKey = keyof typeof RECORDS_DEPOSIT_TABS;
export type RecordsDepositTabIndex =
  (typeof RECORDS_DEPOSIT_TABS)[RecordsDepositTabKey];

// AGENT_CENTER 页面的 Tab 定义
export const AGENT_CENTER_TABS = {
  COMMISSION: "commission",
  TREASURE: "treasure",
} as const;

// AgentCenter Tab 类型
export type AgentCenterTabKey = keyof typeof AGENT_CENTER_TABS;
export type AgentCenterTabValue = (typeof AGENT_CENTER_TABS)[AgentCenterTabKey];

// 路由类型
export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
